module.exports = __webpack_public_path__ + "static/media/facebook.b1ec78fc.svg";